export const FILTERS = [
  {
    key: 'all',
    value: 'All'
  },
  {
    key: 'standard',
    value: 'Standard',
  },
  {
    key: 'status page',
    value: 'Status Page',
  },
  {
    key: 'landing page',
    value: 'Landing Page',
  },
];

export const FILTERKEYS = {
  'standard'    : 'Standard',
  'status page' : 'Status Page',
  'landing page': 'Landing Page'
};


// WEBPACK FOOTER //
// ./src/containers/components/Header/constants/index.js